/**
 * @desc 订舱提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryReserveCabinRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/bookingCabin`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
